import { render, staticRenderFns } from "./MyGet.vue?vue&type=template&id=a54d149e&"
import script from "./MyGet.vue?vue&type=script&lang=js&"
export * from "./MyGet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports